import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  /** If true, the button links out to the external checkout. If false (default), it smooth-scrolls to the offer section. */
  checkout?: boolean;
}
const CHECKOUT_URL = 'https://www.comerybajar.com/cart/53789889069424:1';
export function Button({
  children,
  className = '',
  fullWidth = false,
  checkout = false
}: ButtonProps) {
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const sharedClass = `
    inline-flex items-center justify-center
    bg-brand-gold hover:bg-brand-goldHover text-white 
    font-bold py-4 px-8 rounded-lg shadow-lg 
    transition-colors duration-300 text-center
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (checkout) {
    return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClass} data-id="element-242">
        {children}
      </motion.a>;
  }
  return <motion.a href="#offer" onClick={scrollToOffer} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClass} data-id="element-243">
      {children}
    </motion.a>;
}